import * as React from 'react';
import { FC, useId } from 'react';
import moment from 'moment/moment';
import { moneyStr } from 'app/helpers/money';
import type { Winner } from './types';
import { useLocales } from './locales';

type WinnersProps = { title: string; winners: Winner[]; currency: string; language: string; activeClass: string };

const NoWinners: FC<{ title: string; activeClass: string }> = ({ title, activeClass }) => {
  const l = useLocales();
  const id = useId();
  return (
    <li className={`jw-leaderboard_table-item ${activeClass}`} aria-labelledby={id}>
      <div className="jw-table" id={id}>
        <h4 className="jw-table_title">{title}</h4>
      </div>
      <div className="jw-table_empty">
        <p>{l('no_winners')}</p>
      </div>
    </li>
  );
};

const Winners: FC<WinnersProps> = ({ title, winners, currency, language, activeClass }) => {
  const l = useLocales();
  const id = useId();
  moment.locale(language);
  if (winners.length === 0) return <NoWinners title={title} activeClass={activeClass} />;
  return (
    <li className={`jw-leaderboard_table-item ${activeClass}`} aria-labelledby={id}>
      <div className="jw-table" id={id}>
        <h4 className="jw-table_title">{title}</h4>
      </div>
      <div className="jw-table_top">
        <div className="jw-table_name">{l('player')}</div>
        <div className="jw-table_name">{l('time')}</div>
        <div className="jw-table_name">{l('prize')}</div>
      </div>
      <ul className="jw-table_list" aria-label="winners-list">
        {winners.map((winner) => (
          <li className="jw-table_item">
            <div className="jw-table_player">
              <span>{winner.player}</span>
            </div>
            <div className="jw-table_time">{moment(winner.time).fromNow()}</div>
            <div className="jw-table_prize">{moneyStr(winner.prize, currency)}</div>
          </li>
        ))}
      </ul>
    </li>
  );
};

const WrappedLottery: FC<WinnersProps> = (props) => <Winners {...props} />;

export default WrappedLottery;
